import { Button, ButtonGroup, Modal, Table } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';
import React from 'react';
import { UpdateUserInfo, userUpdateColumns } from '../../../../constants/Dashboard';
import { useDashboard } from '../../../../context/Dashboard/DashboardContext';
import { userUpdateRows } from '../../../../utils/dashboardUtils';
import './DashboardLinkModalUpdateUser.scss';

export type DashboardLinkModalUpdateUserProps = {
  updateUserInfo: UpdateUserInfo;
  errorMessage: string;
  doMigration: (logonId: string, migrationToken: string) => void;
  onClose: () => void;
};

const DashboardLinkModalUpdateUser = ({
  updateUserInfo,
  errorMessage,
  doMigration,
  onClose,
}: DashboardLinkModalUpdateUserProps): JSX.Element => {
  // Get profile from dashboard context
  const { profile } = useDashboard();

  return (
    <>
      <Modal.Content>
        <Alert status="warning" slim className="margin-bottom-2">
          <Alert.Text>
            The user account with User ID <strong>{updateUserInfo.user.logonId}</strong> will be linked to your user
            profile. The following information will be updated.
          </Alert.Text>
        </Alert>

        <div className="link-user-update-table-container">
          <Table
            id="link-user-update-table"
            columns={userUpdateColumns}
            data={userUpdateRows(profile, updateUserInfo.user)}
          />
        </div>

        {errorMessage && (
          <Alert status="error" slim className="margin-top-3">
            <Alert.Text>{errorMessage}</Alert.Text>
          </Alert>
        )}
      </Modal.Content>
      <Modal.Footer className="update-modal-footer">
        <ButtonGroup>
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={(): void => doMigration(updateUserInfo.user.logonId, updateUserInfo.migrationToken)}
          >
            Continue
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </>
  );
};

export default DashboardLinkModalUpdateUser;
